import { useContext, useEffect } from 'react';
import AppConfig from './app-config';

interface AppBarTitleProps {
  /**
   * Title of the Navigation Bar.
   */
  children?: React.ReactNode;
  /**
   * Title of the Navigation bar.
   */
  title?: string;
}

/**
 * Set the text of App Bar.
 *
 * NOTE: `children` is given more preference than `title` prop.
 * @param props Set title of app bar
 */
export function AppBarTitle({ children = '', title = '' }: AppBarTitleProps): null {
  const { setConfig } = useContext(AppConfig.Context);
  const appBarTitle = children || title;
  useEffect(() => {
    setConfig(config => ({ ...config, appBarTitle }));
  }, [appBarTitle, setConfig]);
  return null;
}

/**
 * Get the current app bar text.
 * Note: used in the Layout component. Use `AppBarTitle` to set
 * the title of the app.
 * @internal
 */
export function useAppTitle() {
  return AppConfig.use().appBarTitle;
}
